<template>
  <div
    id="app"
    :class="{
      modalOpen: isBodyScrollPrevented,
    }"
  >
    <complete-profile-banner v-if="user && !user.profileComplete" />
    <navigation />
    <login-modal />
    <router-view />
    <component :is="footer" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Navigation from '@/components/Navigation';
import FooterNavigation from '@/components/FooterNavigation';
import LoginModal from '@/components/modals/Login';
import CompleteProfileBanner from '@/components/CompleteProfileBanner';

export default {
  name: 'app',
  components: {
    Navigation,
    LoginModal,
    FooterNavigation,
    CompleteProfileBanner,
  },
  computed: {
    ...mapState({
      isBodyScrollPrevented: state => state.isBodyScrollPrevented,
      user: state => state.api.user,
    }),
    footer() {
      return `${this.$route.meta.footer || 'default'}-footer`;
    },
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        if (this.user) this.$gtag.set({ userId: this.user.id });
        this.$gtag.set({ dimension2: this.user ? 'member' : 'visitor' });
      },
    },
  },
};
</script>

<style scoped>
.modalOpen {
  position: fixed;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
}
</style>

<style global>
body {
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue